import styles from './WorkWithUs.module.css'

export default function WorkWithUs() {
  return (
    <div className={styles.div}>Work with us</div>
  )
}
